import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  NO_RESULTS_SECTION: `${cleanedFilename(__filename)}-ne-results-section`,
  LIST_ITEM: `${cleanedFilename(__filename)}-list-item`,
};
